import { useUserStore } from '@/pinia/user'
import { useCartStore } from '@/pinia/cart'
// import { useCouponDialog } from './useCouponDialog'
import { metaPixelTrack } from '@/utils/utils'
import { useSearchUrl } from '@/hooks/useSearchUrl'

export const useLogin = () => {
  const route = useRoute()
  const router = useRouter()
  const cartStore = useCartStore()
  const user = useUserStore()
  const { source } = useSearchUrl()
  // const { showCouponDialog } = useCouponDialog()

  const login = async (params) => {
    const data = await user.login({
      registerChannel: source.value ?? 2,
      ...params
    })

    // 给新用户展示满减券弹窗
    if (data?.newUser) {
      /**
       * TODO：临时隐藏，与 9.2.1 新增的邀请注册赠送 运费券 功能冲突
       */
      // showCouponDialog()
      /**
       * Meta Pixel 埋点：注册成功(非登录)
       */
      metaPixelTrack('PRS401', 'Lead', { currency: '$', value: 1 })
    }

    await cartStore.updateCartCount()

    /**
     * 登录完成后需要清除掉 渠道信息 (如果有的话)
     */
    const query = Object.fromEntries(
      Object.entries(route.query).filter(([key]) => {
        return !key.startsWith('utm_') && key !== 'source'
      })
    )

    router.replace({
      path: route.path,
      params: route.params,
      query
    })

    return data
  }

  const logout = async () => {
    await user.logout()
    cartStore.setCartCount(0)
    if (route.meta.auth) {
      router.replace({
        name: 'home'
      })
    }
  }

  return {
    login,
    logout
  }
}
